// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/index.css - Enhanced PWA styles */

@tailwind base;
@tailwind components;
@tailwind utilities;

/* PWA and Mobile Optimizations */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

/* Star rating styles - FIXED */
.star-filled {
  color: #eab308 !important;
  fill: #eab308 !important;
}

.star-empty {
  color: #d1d5db !important;
  fill: none !important;
}

/* PWA Status Bar */
.pwa-status-bar {
  -webkit-app-region: no-drag;
  -webkit-user-select: none;
          user-select: none;
}

/* Offline indicator */
.offline-indicator {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Mobile touch targets */
@media (max-width: 768px) {
  button {
    min-height: 44px;
    min-width: 44px;
  }
  
  input, select, textarea {
    font-size: 16px; /* Prevents zoom on iOS */
  }
}

/* Install button animation */
.install-button {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

/* Loading states */
.loading-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Enhanced focus states for accessibility */
button:focus,
input:focus,
select:focus {
  outline: 2px solid #059669;
  outline-offset: 2px;
}

/* Smooth transitions */
* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

/* PWA splash screen styles */
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #059669 0%, #10b981 50%, #34d399 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Safe area handling for notched devices */
@supports (padding: max(0px)) {
  .safe-area-top {
    padding-top: max(1rem, env(safe-area-inset-top));
  }
  
  .safe-area-bottom {
    padding-bottom: max(1rem, env(safe-area-inset-bottom));
  }
}

/* Fallback styles if Tailwind doesn't work */
.bg-gradient-to-br { 
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 50%, #a7f3d0 100%); 
}
.bg-green-500 { 
  background-color: #10b981; 
}
.bg-green-600 { 
  background-color: #059669; 
}
.text-white { 
  color: white; 
}
.text-green-600 { 
  color: #059669; 
}
.text-gray-800 { 
  color: #1f2937; 
}
.text-gray-600 { 
  color: #4b5563; 
}
.rounded-lg { 
  border-radius: 0.5rem; 
}
.rounded-xl { 
  border-radius: 0.75rem; 
}
.shadow-lg { 
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); 
}
.p-4 { 
  padding: 1rem; 
}
.p-6 { 
  padding: 1.5rem; 
}
.px-4 { 
  padding-left: 1rem; 
  padding-right: 1rem; 
}
.py-2 { 
  padding-top: 0.5rem; 
  padding-bottom: 0.5rem; 
}
.mb-4 { 
  margin-bottom: 1rem; 
}
.mt-4 { 
  margin-top: 1rem; 
}
.flex { 
  display: flex; 
}
.items-center { 
  align-items: center; 
}
.justify-center { 
  justify-content: center; 
}
.space-x-2 > * + * { 
  margin-left: 0.5rem; 
}
.w-full { 
  width: 100%; 
}
.min-h-screen { 
  min-height: 100vh; 
}

/* Custom scrollbar for webkit browsers */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #059669;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #047857;
}

/* Print styles */
@media print {
  .no-print {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB,iCAAiC;AACjC;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe,EAAE,yBAAyB;EAC5C;AACF;;AAEA,6BAA6B;AAC7B;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,4CAA4C;AAC5C;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,+EAA+E;AACjF;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0EAA0E;EAC1E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,sDAAsD;EACxD;AACF;;AAEA,6CAA6C;AAC7C;EACE,0EAA0E;AAC5E;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* src/index.css - Enhanced PWA styles */\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* PWA and Mobile Optimizations */\nhtml, body {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Star rating styles - FIXED */\n.star-filled {\n  color: #eab308 !important;\n  fill: #eab308 !important;\n}\n\n.star-empty {\n  color: #d1d5db !important;\n  fill: none !important;\n}\n\n/* PWA Status Bar */\n.pwa-status-bar {\n  -webkit-app-region: no-drag;\n  user-select: none;\n}\n\n/* Offline indicator */\n.offline-indicator {\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Mobile touch targets */\n@media (max-width: 768px) {\n  button {\n    min-height: 44px;\n    min-width: 44px;\n  }\n  \n  input, select, textarea {\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n}\n\n/* Install button animation */\n.install-button {\n  animation: bounce 2s infinite;\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-10px);\n  }\n  60% {\n    transform: translateY(-5px);\n  }\n}\n\n/* Loading states */\n.loading-spinner {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Enhanced focus states for accessibility */\nbutton:focus,\ninput:focus,\nselect:focus {\n  outline: 2px solid #059669;\n  outline-offset: 2px;\n}\n\n/* Smooth transitions */\n* {\n  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;\n}\n\n/* PWA splash screen styles */\n.splash-screen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #059669 0%, #10b981 50%, #34d399 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n/* Safe area handling for notched devices */\n@supports (padding: max(0px)) {\n  .safe-area-top {\n    padding-top: max(1rem, env(safe-area-inset-top));\n  }\n  \n  .safe-area-bottom {\n    padding-bottom: max(1rem, env(safe-area-inset-bottom));\n  }\n}\n\n/* Fallback styles if Tailwind doesn't work */\n.bg-gradient-to-br { \n  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 50%, #a7f3d0 100%); \n}\n.bg-green-500 { \n  background-color: #10b981; \n}\n.bg-green-600 { \n  background-color: #059669; \n}\n.text-white { \n  color: white; \n}\n.text-green-600 { \n  color: #059669; \n}\n.text-gray-800 { \n  color: #1f2937; \n}\n.text-gray-600 { \n  color: #4b5563; \n}\n.rounded-lg { \n  border-radius: 0.5rem; \n}\n.rounded-xl { \n  border-radius: 0.75rem; \n}\n.shadow-lg { \n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); \n}\n.p-4 { \n  padding: 1rem; \n}\n.p-6 { \n  padding: 1.5rem; \n}\n.px-4 { \n  padding-left: 1rem; \n  padding-right: 1rem; \n}\n.py-2 { \n  padding-top: 0.5rem; \n  padding-bottom: 0.5rem; \n}\n.mb-4 { \n  margin-bottom: 1rem; \n}\n.mt-4 { \n  margin-top: 1rem; \n}\n.flex { \n  display: flex; \n}\n.items-center { \n  align-items: center; \n}\n.justify-center { \n  justify-content: center; \n}\n.space-x-2 > * + * { \n  margin-left: 0.5rem; \n}\n.w-full { \n  width: 100%; \n}\n.min-h-screen { \n  min-height: 100vh; \n}\n\n/* Custom scrollbar for webkit browsers */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #059669;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #047857;\n}\n\n/* Print styles */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
